import './index.css'
import Button from '../button';
import { useState ,useEffect } from 'react';
import { handleSignUpAttempt } from '../../functions/signup';

function Form() {
  const [checkOutURL, setCheckOutURL] = useState(process.env.REACT_APP_BACKEND_URL + "/create-checkout-session");
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);
  const [password, setPassword] = useState(null);
  const [productId, setProductId] = useState('price_1RC2TN06lJfTdtb1n2wJqYeb');
  const [error, setError] = useState('');

  // Update checkout URL whenever email, name, password, or productId changes
  useEffect(() => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/create-checkout-session?email=${email}&name=${name}&password=${password}&productId=${productId}`;
    setCheckOutURL(url);
  }, [email, name, password, productId]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Perform email validation via an API call or some other method
    const response = await handleSignUpAttempt();
    console.log(response);
    
    if (response.success) {
      // If validation is successful, proceed with form submission
      console.log("successful attempt wahey!!");
      const date = new Date();
      date.setMonth(date.getMonth() + 1); // Add one month to current date
      let toSetDate = date.toUTCString(); // Format it as UTC string for cookie
      document.cookie = `mako_auth=${response.auth_code}; expires=${toSetDate}; path=/; SameSite=None; Secure`;
      window.location.href = "/onboarding"; // Redirect to the "/onboarding" page
      //document.getElementById('checkout-form').submit();
    } else {
      // If validation fails, display an error message
      setError(response.errorMessage || 'An error occurred. Please try again.');
    }
  };

  return (
    <div className="form-wrapper">
      <div className="form">
        <input 
          id="name-input" 
          onInput={(e) => setName(e.target.value)} 
          placeholder="Name" 
          autoComplete="off" 
          className="small-text"
        />
        <input 
          id="email-input" 
          onInput={(e) => setEmail(e.target.value)} 
          type="email" 
          placeholder="Email" 
          autoComplete="off" 
          className="small-text"
        />
        <input 
          id="password-input" 
          onInput={(e) => setPassword(e.target.value)} 
          type="password" 
          placeholder="Password" 
          autoComplete="off" 
          className="small-text"
        />
        <form id='checkout-form' action={checkOutURL} method='POST'>
          <button type='button' className='button small-text' onClick={handleSubmit}>
            Start 7 day free trial
          </button>
        </form>
        <div id="error-message" className="small-text">{error}</div>
      </div>
    </div>
  );
}

export default Form;
